import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

export const BreakpointsTailwind = {
  Small: '(min-width: 640px)',
  Medium: '(min-width: 768px)',
  Large: '(min-width: 1024px)',
  XLarge: '(min-width: 1280px)',
  Handset: '(max-width: 639px)',
  Tablet: '(min-width: 640px) and (max-width: 1023px)',
  Web: '(min-width: 1024px)',
};

@Injectable({
  providedIn: 'root',
})
export class BreakpointsService {
  readonly #breakpointObserver = inject(BreakpointObserver);

  // ── Tailwind breakpoints ────────────────────────────────────────────────────

  /** < 640px */
  readonly isHandset$: Observable<boolean>;
  /** ≥ 640px */
  readonly isSm$: Observable<boolean>;
  /** ≥ 768px */
  readonly isMd$: Observable<boolean>;
  /** ≥ 1024px */
  readonly isLg$: Observable<boolean>;
  /** ≥ 1280px */
  readonly isXl$: Observable<boolean>;
  /** 640px – 1023px */
  readonly isTablet$: Observable<boolean>;

  // ── Deprecated ──────────────────────────────────────────────────────────────

  /** @deprecated Use {@link isHandset$} instead */
  readonly isMobile$: Observable<boolean>;
  /** @deprecated Use {@link isLg$} instead */
  readonly isWeb$: Observable<boolean>;
  /** @deprecated Use {@link isTablet$} instead */
  readonly isTabletPortrait$: Observable<boolean>;
  /** @deprecated Use {@link isHandset$} or combine with {@link isTablet$} instead */
  readonly isMobileAndTabletPortrait$: Observable<boolean>;

  constructor() {
    this.isHandset$ = this.observe(BreakpointsTailwind.Handset);
    this.isSm$ = this.observe(BreakpointsTailwind.Small);
    this.isMd$ = this.observe(BreakpointsTailwind.Medium);
    this.isLg$ = this.observe(BreakpointsTailwind.Large);
    this.isXl$ = this.observe(BreakpointsTailwind.XLarge);
    this.isTablet$ = this.observe(BreakpointsTailwind.Tablet);

    this.isMobile$ = this.observe(Breakpoints.Handset);
    this.isWeb$ = this.observe(Breakpoints.Web);
    this.isTabletPortrait$ = this.observe(Breakpoints.TabletPortrait);
    this.isMobileAndTabletPortrait$ = this.observe(Breakpoints.Handset, Breakpoints.TabletPortrait);
  }

  private observe(...queries: string[]): Observable<boolean> {
    return this.#breakpointObserver.observe(queries).pipe(
      map((result) => result.matches),
      distinctUntilChanged(),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }
}
